import React from "react";
export const AstraicField = () => {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.02164 11.1944L4.19297 7.38915L0.982868 9.45407L0 7.74082L3.40848 6.00051L0 4.2602L0.982868 2.54695L4.19297 4.61187L4.02164 0.806641H5.97836L5.80703 4.61187L9.01713 2.54695L10 4.2602L6.59152 6.00051L10 7.74082L9.01713 9.45407L5.80703 7.38915L5.97836 11.1944H4.02164Z"
        fill="url(#paint0_linear_1188_55321)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1188_55321"
          x1="4.54019e-08"
          y1="6.0005"
          x2="10"
          y2="6.0005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFCB57" />
          <stop offset="1" stopColor="#FF7443" />
        </linearGradient>
      </defs>
    </svg>
  );
};
